import { addScript } from '@tunein/web-utils';
import { recaptchaSiteKey } from '../../constants/auth/recaptcha';

function readyCallback(action, resolve) {
  return async () => {
    const token = await window.grecaptcha.execute(recaptchaSiteKey, { action });
    resolve(token);
  };
}

const RECAPTCHA_V2_SCRIPT_SRC = 'https://www.google.com/recaptcha/api.js?render=explicit';
let recaptchaV2ScriptPromise = null;

export async function loadRecaptchaV2Script() {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return Promise.resolve();
  }

  if (recaptchaV2ScriptPromise) {
    return recaptchaV2ScriptPromise;
  }

  if (window.grecaptcha && typeof window.grecaptcha.render === 'function') {
    recaptchaV2ScriptPromise = Promise.resolve();
    return recaptchaV2ScriptPromise;
  }

  try {
    recaptchaV2ScriptPromise = addScript({
      src: RECAPTCHA_V2_SCRIPT_SRC,
      async: true,
      attributes: { defer: 'true' },
    });

    await recaptchaV2ScriptPromise;
  } catch (error) {
    recaptchaV2ScriptPromise = null;

    throw error;
  }
}

export function getRecaptchaToken(action, onError) {
  if (!window.grecaptcha) {
    onError({
      message: 'Recaptcha V3: grecaptcha not defined',
      context: { action },
    });
    return null;
  }

  return new Promise((resolve) => {
    try {
      window.grecaptcha.ready(readyCallback(action, resolve));
    } catch (e) {
      onError({
        message: 'Recaptcha V3: error fetching token',
        context: { action },
      });
      resolve(null);
    }
  });
}
